import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import Grid from '@mui/material/Grid'
import { InputLabel, TextField, useMediaQuery, useTheme } from '@mui/material'
import { HelperWrapper, ShowPassowrdIcon, TextInputWithHelper } from 'src/components'

import { useStyles } from './styles'

export const AuthPasswordInput = () => {
  const [t] = useTranslation()
  const { errors, values, handleChange } = useFormikContext<{ password: string }>()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword((toggle) => !toggle)

  return (
    <Grid item xs={12} className={classes.containerField}>
      <TextInputWithHelper
        fullWidth
        inputName="password"
        type={showPassword ? 'text' : 'password'}
        endIcon={<ShowPassowrdIcon showPassword={showPassword} onClick={handleClickShowPassword} />}
        handleChange={handleChange}
        value={values.password}
        error={errors.password ? t(errors.password + '.v') : ''}
        inputUpperLabel={<HelperWrapper t={'password-input-label'} isInputLable isMandatory />}
      />
    </Grid>
  )
}
